import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import GenericList from '~/components/GenericList/GenericList';

//assets
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';

/**
 * Paginated list of the managers assigned to one employee. Shared by the Manager column on the
 * users list and the logged-in user's own profile menu - both read the same endpoint, which only
 * lets a member see their own managers.
 */
class UserManagersModal extends Component {
    constructor(props) {
        super(props);
        this.state = { page: 0 };
    }

    handlePageChange = (page) => {
        this.setState({ page });
    }

    render() {
        const { t, userStore, userId, userName, show, onHide } = this.props;
        const { page } = this.state;

        if (!userId) return null;

        return (
            <Modal size="lg" show={!!show} onHide={onHide} centered>
                <Modal.Header>
                    <Modal.Title className="w-100 text-center m-0">
                        {userName ? `${t('Managers')} - ${userName}` : t('Managers')}
                    </Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        alt="close_button"
                        onClick={onHide}
                    />
                </Modal.Header>
                <Modal.Body>
                    <div className="table-list">
                        <GenericList
                            key={userId}
                            columns={[
                                {
                                    Header: 'Manager',
                                    id: 'full_name',
                                    accessor: ({ full_name }) => <span className="text-capitalize">{full_name}</span>,
                                    textAlign: 'start',
                                },
                                {
                                    Header: 'Email',
                                    id: 'email',
                                    accessor: ({ email }) => <span>{email || '-'}</span>,
                                    textAlign: 'start',
                                },
                                {
                                    Header: 'Manager Type',
                                    id: 'is_assigned_directly',
                                    accessor: ({ is_assigned_directly }) => <span>{is_assigned_directly ? t('Direct Manager') : t('Assigned through project')}</span>,
                                    textAlign: 'start',
                                },
                            ]}
                            requestData={(params) => userStore.getUserManagers(userId, params)}
                            page={page}
                            handlePageChange={this.handlePageChange}
                            showPageSizeSelector
                            pageSizeListId="user_managers"
                        />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default inject('userStore')(withLocalization(observer(UserManagersModal)));
